import IframeActivity from "./IframeActivity";

export default function ClearDirections() {
    return (
        <IframeActivity
            src="/activities/clear-directions/index.html"
            title="Clear Directions"
        />
    );
}